import axios from "axios";
import store from "../store/index";
// 判断插件版本 是否更新
export function checkPlug(func, tipFunc) {
    let currentVersion = '1.0.11'
    let div = document.getElementById("div_updatePrice");
    if (div) {
        func()
        let version = div.getAttribute("version");
        if (version !== currentVersion) {
            tipFunc()
        }
    }
}

// 字符串转数组
export function str_arr(val) {
    let snsArr = val.split(/[(\r\n)\r\n]+/);
    let uPattern = /[^\r\n0-9 a-zA-Z_-]/g;
    for (let i = snsArr.length; i > -1; i--) {
        if (!snsArr[i]) {
            snsArr.splice(i, 1); //删除空项
        } else {
            snsArr[i] = snsArr[i].trim();
        }
        if (snsArr[i] == "") {
            snsArr.splice(i, 1);
        }
        if (uPattern.test(snsArr[i])) {
            snsArr.splice(i, 1);
        }
    }
    return snsArr;
}

export function str_arr_no_limit(val) {
    let snsArr = val.split(/[(\r\n)\r\n]+/);
    for (let i = snsArr.length; i > -1; i--) {
        if (!snsArr[i]) {
            snsArr.splice(i, 1); //删除空项
        } else {
            snsArr[i] = snsArr[i].trim();
        }
        if (snsArr[i] == "") {
            snsArr.splice(i, 1);
        }
    }
    return snsArr;
}

// 跳转链接映射
export function link_us(str) {
    if (str == "US") {
        return "https://www.amazon.com/";
    } else if (str == "CA") {
        return "https://www.amazon.ca/";
    } else if (str == "MX") {
        return "https://www.amazon.mx/";
    } else if (str == "DE") {
        return "https://www.amazon.de/";
    } else if (str == "ES") {
        return "https://www.amazon.es/";
    } else if (str == "FR") {
        return "https://www.amazon.fr/";
    } else if (str == "IN") {
        return "https://www.amazon.in/";
    } else if (str == "IT") {
        return "https://www.amazon.it/";
    } else if (str == "UK") {
        return "https://www.amazon.co.uk/";
    } else if (str == "JP") {
        return "https://www.amazon.co.jp/";
    } else if (str == "AU") {
        return "https://www.amazon.com.au/";
    } else if (str == "BR") {
        return "https://www.amazon.com.br/";
    }
}

//二进制下载
export function binary_download(url, method, params, data, str, name, baseURL) {
    return new Promise(resolve => {
        // 创建axios实例
        const service = axios.create({
            baseURL: baseURL || "https://ssl.maijiaseller.com/", // api 的 base_url
            timeout: 600000 // 请求超时时间
        });
        // request拦截器
        service.interceptors.request.use(
            config => {
                if (store.getters.token) {
                    config.headers["token"] = store.getters.token; // 让每个请求携带自定义token 请根据实际情况自行修改
                }
                return config;
            },
            error => {
                Promise.reject(error);
            }
        );
        service({
            url: url,
            method: method,
            responseType: "arraybuffer",
            params: {
                ADMIN_ID: store.getters.adminId,
                ADMIN_TOKEN: store.getters.token,
                ...params
            },
            data: data
        }).then(res => {
            const blob = new Blob([res.data], {
                // type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                type: str
            });
            const fileName = name;
            // for IE
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
                // for Non-IE
                const objectUrl = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = objectUrl;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
                resolve({ code: 0 });
            }
        });
    });
}
/**
 * 根据url下载
 * @param {*} dataUrl
 */

export function downLoadFilePy(file_path, name = "文件导出") {
    binary_download(
        "/apis/v1/common_file_export_by_path",
        "post",
        {},
        {
            file_path
        },
        "application/vnd.ms-excel",
        `${name}.xlsx`
    );
}
/**
 * 下载blob文件
 * @param {*} blob
 * @param {*} fileName
 * @param {*} clearTime
 */
export const downloadFileUrl = (dataUrl, fileName, clearTime = 10000) => {
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = dataUrl;

    // link.setAttribute("download", fileName || "下载.xls");
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
        document.body.removeChild(link);
    }, clearTime);
};

/**
 * 下载blob文件
 * @param {*} blob
 * @param {*} fileName
 * @param {*} clearTime
 */
export const downloadBlobFile = (blob, fileName, clearTime = 10000) => {
    if (!blob || !(blob instanceof Blob)) {
        return;
    }
    let url = window.URL.createObjectURL(new Blob([blob]));
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    link.setAttribute("download", fileName || "下载.xls");
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
        document.body.removeChild(link);
    }, clearTime);
};
